module.exports = __webpack_public_path__ + "static/media/icn-arrow.50bcb74c.svg";